import axios from "./axios";

export async function fetchProductCategories(controller) {
  const params = new URLSearchParams();
  if (controller.page) params.append("page", controller.page);
  if (controller.per_page) params.append("per_page", controller.per_page);
  if (controller.sort) params.append("sort", controller.sort);
  if (controller.sortBy) params.append("sortBy", controller.sortBy);
  if (controller.query) params.append("query", controller.query);
  if (controller.parents !== undefined) params.append("parents", controller.parents);
  if (controller.parent_id) params.append("parent_id", controller.parent_id);

  return axios.get(`/products/categories?${params.toString()}`);
}

export async function fetchProductCategory(id) {
  return axios.get(`/products/categories/` + id);
}

export async function createProductCategory(payload) {
  return axios.post(`/products/categories`, { category: payload });
}

export async function updateProductCategory(payload) {
  return axios.put(`/products/categories/${payload.id}`, { category: payload });
}

export async function deleteProductCategory(payload) {
  return axios.delete(`/products/categories/${payload.id}`, {
    data: payload,
  });
}

